/**
 * Service for cost center export operations
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import { buildQueryString } from '@/api/shared/queryBuilder';
import type { ApiResponse } from '@/api/shared/types';
import type { CostCentersExportFilters } from '../types';


export class CostCenterExportService {
  async export(filters?: CostCentersExportFilters)
    : Promise<ApiResponse<{ blob: Blob; filename: string }>> {
    const queryString = buildQueryString(filters ?? {});
    const endpoint = `${API_CONFIG.ENDPOINTS.ORGANIZATION.EXPORT_COST_CENTERS}${queryString}`;

    const response = await apiClient.downloadBlobWithFilename(endpoint, {
      method: 'GET',
    });

    if (response.success && response.data) {
      return response;
    }

    return { ...response, data: null };
  }
}

export const costCenterExport = new CostCenterExportService();
